import { supabase } from '../../../lib/supabaseClient';

export async function getProjectContractSettings(projectId) {
  const { data, error } = await supabase
    .from('project_contract_settings')
    .select('*')
    .eq('project_id', projectId)
    .maybeSingle();

  if (error) throw error;
  return data;
}

export async function upsertProjectContractSettings(projectId, settings) {
  const { data, error } = await supabase
    .from('project_contract_settings')
    .upsert({
      project_id: projectId,
      ...settings,
      updated_at: new Date().toISOString(),
    }, {
      onConflict: 'project_id'
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteProjectContractSettings(projectId) {
  const { error } = await supabase
    .from('project_contract_settings')
    .delete()
    .eq('project_id', projectId);

  if (error) throw error;
}

export async function validateReservationForASP(reservationId) {
  const { data, error } = await supabase
    .rpc('validate_reservation_for_asp', {
      p_reservation_id: reservationId
    });

  if (error) throw error;
  return data;
}
